/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notif_Type_Sla_BreachInputs */

const vi_notif_type_sla_breach = /** @type {(inputs: Notif_Type_Sla_BreachInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã quá hạn`)
};

/**

* @param {Notif_Type_Sla_BreachInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const notif_type_sla_breach = /** @type {((inputs?: Notif_Type_Sla_BreachInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notif_Type_Sla_BreachInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_notif_type_sla_breach(inputs)
});